export const ProductionStatus = {
	ACCEPTANCE_PENDING: 1,
	IN_PROCESS: 2,
	PICKED_UP_BY_COURIER: 3,
	DELIVERING: 4,
	CANCELLED: 5,
	COMPLETED: 6,
	DENIED: 7,
	QUALITY_CONTROL: 8,
	// PAUSED: 9, // linea 305 en 'src/common/Utils/StringUtilities.js' dice que el estado 9 es 'REFUNDED'. Eso no existe en la base de datos, pero entiendo que es correcto en el código. TODO investigar esto
	// PAUSED: 10, // al parecer el estado 10 también existe y es Envío Parcial, que tampoco está en la base de datos. TODO investigar esto
	PAUSED: 11,
}
